export const handleAsyncCall = async (promise, handleError = () => { }) => {
    try {
        const data = await promise();
        return [data, null];
    } catch (e) {
        handleError(e);
        return [null, e];
    }
};